export default payload => (dispatch) => {
  dispatch({ type: "APP/THEME/MODE", payload });
};
